
'use client';

import React from 'react';
import { DemoBanner } from '@/components/DemoBanner';
import { ArrowRight, ChevronRight, Layout, Palette, Code, Target, Phone, Mail, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AgencyDemo() {
  return (
    <div className="min-h-screen bg-[#0f172a] text-white pt-11 font-sans selection:bg-white selection:text-black">
      <DemoBanner />

      {/* NAVIGATION */}
      <nav className="border-b border-white/5 py-6 sticky top-11 bg-[#0f172a]/80 backdrop-blur-xl z-40">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div className="text-2xl font-black tracking-tighter italic">NEXUS</div>
          <div className="hidden lg:flex items-center gap-10 text-[11px] font-bold uppercase tracking-[0.3em] text-white/50">
            <a href="#" className="text-white">Haqimizda</a>
            <a href="#" className="hover:text-white transition-colors">Xizmatlar</a>
            <a href="#" className="hover:text-white transition-colors">Loyihalar</a>
            <a href="#" className="hover:text-white transition-colors">Jamoa</a>
            <a href="#" className="hover:text-white transition-colors">Bog'lanish</a>
          </div>
          <Button className="bg-white text-black hover:bg-gray-100 rounded-none h-12 px-8 font-bold uppercase text-[10px] tracking-widest">
            Konsultatsiya olish
          </Button>
        </div>
      </nav>

      {/* HERO */}
      <section className="py-24 md:py-48 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[50vw] h-[50vw] bg-blue-600/20 rounded-full blur-[150px] -translate-y-1/2 translate-x-1/2" />
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <h1 className="text-6xl md:text-8xl font-black tracking-tighter leading-[0.95] mb-12">
              Biznesingizni Keyingi <br /> <span className="text-white/40 italic">Bosqichga</span> Olib Chiqamiz
            </h1>
            <p className="text-xl md:text-2xl text-white/60 mb-16 max-w-2xl font-medium">
              Strategiya, brending va raqamli transformatsiya orqali biznesingizning yangi imkoniyatlarini ochamiz.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 mb-24">
              <Button size="lg" className="h-16 px-12 bg-white text-black hover:bg-gray-100 font-bold rounded-none text-xs uppercase tracking-widest">
                Loyiha Boshlash
              </Button>
              <Button size="lg" variant="outline" className="h-16 px-12 border-white/20 hover:bg-white/5 font-bold rounded-none text-xs uppercase tracking-widest">
                Ishlarimizni Ko'ring
              </Button>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 border-t border-white/10 pt-16">
               <div>
                  <div className="text-4xl font-black mb-2 tracking-tighter">15+</div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40">Yil Tajriba</div>
               </div>
               <div>
                  <div className="text-4xl font-black mb-2 tracking-tighter">200+</div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40">Muvaffaqiyatli Loyiha</div>
               </div>
               <div>
                  <div className="text-4xl font-black mb-2 tracking-tighter">50+</div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/40">Professional Jamoa</div>
               </div>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="py-32 bg-white/5">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { title: "Brend Strategiya", desc: "Brendingizni taniy olinadigan va kuchli qiling", icon: Target },
              { title: "UI/UX Dizayn", desc: "Foydalanuvchilar uchun mukammal raqamli tajriba", icon: Palette },
              { title: "Web Rivojlantirish", desc: "Yuqori texnologiyali va tezkor web yechimlar", icon: Code },
              { title: "Raqamli Marketing", desc: "Mijozlaringiz sonini bir necha barobar oshiring", icon: Layout },
            ].map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="p-10 border border-white/10 hover:bg-white/5 transition-all group">
                   <Icon size={32} className="text-white/40 mb-8 group-hover:text-white transition-colors" />
                   <h3 className="text-xl font-bold mb-4">{s.title}</h3>
                   <p className="text-white/40 text-sm leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="py-24 border-t border-white/5">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-20 items-end">
            <div>
              <div className="text-4xl font-black tracking-tighter italic mb-12">NEXUS</div>
              <div className="space-y-6 text-white/60">
                <div className="flex items-center gap-6">
                  <Phone size={20} /> +998 71 300 00 00
                </div>
                <div className="flex items-center gap-6">
                  <Mail size={20} /> hello@nexus.uz
                </div>
                <div className="flex items-center gap-6">
                  <MapPin size={20} /> Toshkent, Uzbekistan
                </div>
              </div>
            </div>
            <div className="text-right">
              <p className="text-[10px] font-bold uppercase tracking-[0.4em] text-white/20 mb-8">© 2026 NEXUS AGENCY</p>
              <div className="flex justify-end gap-10 text-[10px] font-bold uppercase tracking-widest text-white/40">
                <a href="#" className="hover:text-white">Instagram</a>
                <a href="#" className="hover:text-white">LinkedIn</a>
                <a href="#" className="hover:text-white">Twitter</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
